interface Column {
  id: 'invoiceDate' | 'invoiceNumber' | 'amount' | 'status' | 'download';
  label: string;
  minWidth?: number;
  align?: 'left' | 'right';
}

export const columns: readonly Column[] = [
  {
    id: 'invoiceDate',
    label: 'Date',
    minWidth: 119
  },
  {
    id: 'invoiceNumber',
    label: 'Invoice Number',
    minWidth: 175
  },
  {
    id: 'amount',
    label: 'Amount',
    minWidth: 119
  },
  {
    id: 'status',
    label: 'Status',
    minWidth: 224
  },
  {
    id: 'download',
    label: 'Download',
    minWidth: 105,
    align: 'right'
  },
];
